import { Controller } from "react-hook-form";
import translation from "../translation";
import Select, { components } from "react-select";
import { useLocale } from "hooks";
import { responsive } from "utils/theme";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <svg
        width="10"
        height="5"
        viewBox="0 0 10 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 0L5 5L10 0H0Z" fill="black" />
      </svg>
    </components.DropdownIndicator>
  );
};

const CategorySelect = ({ options, control }) => {
  const { locale, isRTL } = useLocale();
  return (
    <>
      <style global jsx>{`
        .react-select__placeholder {
          font-size: 14px;
        }
        .react-select__control {
          padding: ${isRTL ? 5.5 : 8}px 16px;
        }

        @media only screen and (min-width: ${responsive.xxxl}px) {
          .react-select__placeholder {
            font-size: 18.67px;
          }
          .react-select__control {
            padding: ${isRTL ? 9.5 : 12.5}px 12px;
          }
        }
      `}</style>
      <Controller
        name="category"
        control={control}
        render={({ field }) => (
          <Select
            classNamePrefix={"react-select"}
            noOptionsMessage={() => translation[locale]?.NO_OPTIONS}
            {...field}
            styles={{
              option: (provided, state) => ({
                ...provided,
              }),
              control: (provided) => ({
                ...provided,
                borderRadius: 8,
              }),
              indicatorSeparator: () => ({
                display: "none",
              }),
            }}
            components={{ DropdownIndicator }}
            placeholder={translation[locale]?.OPTIONS_PLACEHOLDER}
            options={options}
            isSearchable={false}
            // getOptionLabel={(option) => option.label === 'همه'? 'انتخاب کنید' : option.label}
            // formatOptionLabel={(option) => option.label === 'همه'? 'انتخاب کنید' : option.label}
            // formatGroupLabel={(option) => option.label === 'همه'? 'انتخاب کنید' : option.label}
          />
        )}
      />
    </>
  );
};

export default CategorySelect;
